import type {ScheduleItem} from '@domain/schedule'
import {OperationModeSnapshot} from '@hconnect/common/types'

import {splitToIntervals} from '../../shared/selectors/time'

/**
 * Mock-only helper that builds a quarter-hourly power consumption dictionary for
 * a schedule item. The production implementation lives in the production-planning
 * feature; this local copy keeps the hcem mocks self-contained during deprecation.
 */
export const getScheduleItemPowerConsumptionQuaterlyDict = (
  scheduleItem: Pick<ScheduleItem, 'start' | 'end'>,
  operationMode: OperationModeSnapshot
) => {
  const {start, end} = scheduleItem
  const powerConsumption = operationMode.powerConsumption
  const powerConsumptionIntervals = splitToIntervals(start, end, 15).map(({start, end}) => ({
    start,
    end,
    power: powerConsumption ?? 0
  }))

  return Object.fromEntries(powerConsumptionIntervals.map((entry) => [entry.start, entry.power]))
}
